export default __webpack_public_path__ + "static/media/minus.6458cab2.svg";